import { apiCall } from "./authServices";

export const CreateMvr = async ({ payload }) => {
  try {
    const response = await apiCall({
      endpoint: "api/manual/mvr/add-mvr",
      method: "POST",
      payload,
    });
    return response;
  } catch (error) {
    throw error;
  }
};

export const FetchMvr = async () => {
  try {
    const res = await apiCall({
      endpoint: "api/manual/mvr/get-all-mvr",
      method: "GET",
    });
    if (res.success) {
      const updatedData = [];
      const mvrDetail = res.mvrDetails;
    //   if (mvrDetail && mvrDetail.length) {
    //     for (let i = 0; i < mvrDetail.length; i++) {
    //       const mvr = mvrDetail[i];
    //       const newMvr = {
    //         id: res.id,
    //         dvrVersion: mvr.evaluationName,
    //         createdDate: mvr.createdAt,
    //         submittedDate: "12-10-2024",
    //         status: mvr.mvrStatus,
    //         approvedDate: "12-10-2024",
    //         validFrom: mvr.activeFrom,
    //         validTo: mvr.activeTo,
    //       };
    //       updatedData.push(newMvr)
    //     }
    //   }
      res.mvrDetail = updatedData
    }
    return res;
  } catch (error) {
    throw error;
  }
};

export const UpdateManual = async ({payload}) => {
  try {
    const res = await apiCall({
      endpoint: "api/manual/mvr/add-manual",
      method: "post",
      payload: payload
    });
    if (res.success) {
      console.log(res)
    }
    return res;
  } catch (error) {
    throw error;
  }
};
export const GetMVRDetails = async ({parmas= null}) => {
  try {
    if(parmas){
      const endpoint = `api/manual/mvr/get-manual/${parmas}`
      const res = await apiCall({
        endpoint: endpoint,
        method: "get",
      });
      if (res.success) {
        return res
      }
      return res;
    }
  } catch (error) {
    throw error;
  }
};

export const DeleteMvr = async ({mvrId= null}) => {
  try {
    if(mvrId){
      const endpoint = `api/manual/mvr/delete-mvr/${mvrId}`
      const res = await apiCall({
        endpoint: endpoint,
        method: "Delete",
      });
      if (res.success) {
        return res
      }
      return res;
    }
  } catch (error) {
    throw error;
  }
};

// debounced searching
export const DebouncedValidation = async ({payload}) => {
  try{
    const endpoint = 'api/manual/mvr/mvr-uniqueness-validation';
    const res = await apiCall({
      endpoint: endpoint,
      method: 'POST',
      payload: payload,
    })
    console.log(res, ' got my api response')
    return res;
  }catch(error){
    throw error;
  }
}

// mvr approval service
export  const MVRApprovalDataFetch = async () => {
  try{
    const endpoint = 'api/manual/mvr/get-mvr-approvals';
    const res = await apiCall({
      endpoint: endpoint,
      method: 'GET',
    })
    return res;
  }catch(error){
    throw error;
  }
}